import { useQuery } from '@tanstack/react-query';
import { GetCompanyInfo, GetFooter, GetHomeSliderItems, GetNavBarItems, GetRegistrationProfits, GetSuppliersLogo } from '../Services/CompanyInfoService';
import { useConfig } from '../Providers/ConfigProvider';

// Klucz cache dla danych firmowych. Ten sam klucz we wszystkich miejscach oznacza,
// że niezależnie od tego ile komponentów zawoła ten hook, do API poleci JEDEN komplet
// zapytań, a każdy komponent dostanie dane z tego samego cache.
export const COMPANY_INFO_QUERY_KEY = ['companyInfo']

const useGetCompanyInfo = () => {
  const { api } = useConfig()

  const { data, isLoading } = useQuery({
    queryKey: COMPANY_INFO_QUERY_KEY,
    queryFn: async () => {
      const [companyRes, footerRes, navBarRes, supplierRes, homeSliderRes, registrationProfitsRes] = await Promise.all([
        GetCompanyInfo(api),
        GetFooter(api),
        GetNavBarItems(api),
        GetSuppliersLogo(api),
        GetHomeSliderItems(api),
        GetRegistrationProfits(api)
      ])
      return {
        companyInfoData: companyRes.data,
        footerData: footerRes.data,
        navBarItems: navBarRes.data,
        supplierLogoItems: supplierRes.data,
        homeSliderItems: homeSliderRes.data,
        registrationProfits: registrationProfitsRes.data,
      }
    },
    // Dane firmowe (stopka, kontakt, slidery) zmieniają się rzadko - trzymamy je
    // 30 minut bez odpytywania API. Po zmianie w panelu administratora trzeba
    // unieważnić cache: queryClient.invalidateQueries({ queryKey: COMPANY_INFO_QUERY_KEY })
    staleTime: 30 * 60 * 1000,
  })

  return {
    footerData: data?.footerData ?? [],
    companyInfoData: data?.companyInfoData ?? [],
    navBarItems: data?.navBarItems ?? [],
    supplierLogoItems: data?.supplierLogoItems ?? [],
    homeSliderItems: data?.homeSliderItems ?? [],
    registrationProfits: data?.registrationProfits ?? [],
    loadingData: isLoading,
  }
}

export default useGetCompanyInfo
